import { render } from "./BilanciPrevisionali.vue?vue&type=template&id=44d3327d&ts=true"
import script from "./BilanciPrevisionali.vue?vue&type=script&lang=ts"
export * from "./BilanciPrevisionali.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__